import React from 'react';
import { Award } from 'lucide-react';
import type { useApplicationDetail } from '../../hooks/useApplicationDetail';

interface Props { h: ReturnType<typeof useApplicationDetail>; }

export const CertificateArchive: React.FC<Props> = ({ h }) => {
  const { certificates, showCertificateArchive, loadingCertificates } = h;

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold flex items-center">
          <Award className="mr-2 text-amber-600" size={24} />
          Baza Certyfikatów
        </h2>
        <div className="flex gap-2">
          {!showCertificateArchive ? (
            <button onClick={() => { h.setShowCertificateArchive(true); h.loadCertificates(); }} className="bg-amber-500 text-white px-4 py-2 rounded-lg hover:bg-amber-600 flex items-center text-sm">
              Pokaż archiwum
            </button>
          ) : (
            <button onClick={() => h.setShowCertificateArchive(false)} className="bg-gray-500 text-white px-4 py-2 rounded-lg hover:bg-gray-600 flex items-center text-sm">
              Ukryj
            </button>
          )}
        </div>
      </div>

      {showCertificateArchive && (
        <div className="space-y-3">
          {loadingCertificates ? (
            <p className="text-gray-500 italic">Ładowanie certyfikatów...</p>
          ) : certificates.length === 0 ? (
            <p className="text-gray-500 italic">Brak wygenerowanych certyfikatów dla tego wniosku.</p>
          ) : (
            <>
              <div className="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg flex items-center justify-between">
                <div>
                  <p className="text-sm font-semibold text-amber-900">Znaleziono {certificates.length} certyfikat(ów)</p>
                  <p className="text-xs text-amber-700">Możesz pobrać pojedyncze certyfikaty lub wszystkie razem jako PDF</p>
                </div>
                <button onClick={h.handleDownloadAllCertificatesPDF} className="bg-amber-600 text-white px-4 py-2 rounded-lg hover:bg-amber-700 flex items-center text-sm whitespace-nowrap">
                  Pobierz wszystkie PDF
                </button>
              </div>
              <div className="grid gap-3">
                {certificates.map((cert: any) => (
                  <div key={cert.id} className="border-2 border-amber-100 rounded-lg p-4 bg-gradient-to-r from-amber-50 to-yellow-50 hover:shadow-md transition-shadow">
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <div className="flex items-center mb-2">
                          <Award className="text-amber-600 mr-2" size={20} />
                          <h3 className="font-semibold text-gray-800">{cert.certificate_title}</h3>
                        </div>
                        <div className="space-y-1 text-sm text-gray-600">
                          <p><span className="font-medium">Typ:</span> {cert.certificate_type === 'course' ? 'Kurs' : cert.certificate_type === 'internship' ? 'Praktyki' : cert.certificate_type === 'volunteer' ? 'Wolontariat' : cert.certificate_type === 'reference' ? 'Referencje' : cert.certificate_type}</p>
                          {cert.recipient_name && <p><span className="font-medium">Odbiorca:</span> {cert.recipient_name}</p>}
                          {cert.certificate_number && <p><span className="font-medium">Numer:</span> {cert.certificate_number}</p>}
                          {cert.course_title && <p><span className="font-medium">Kurs:</span> {cert.course_title}</p>}
                          <p className="text-xs text-gray-500"><span className="font-medium">Wygenerowano:</span> {new Date(cert.generated_at).toLocaleString('pl-PL')}</p>
                        </div>
                      </div>
                      <button onClick={() => h.handleDownloadCertificatePDF(cert.id, cert.certificate_title)} className="ml-4 bg-blue-500 text-white px-3 py-2 rounded-lg hover:bg-blue-600 flex items-center text-sm whitespace-nowrap">
                        Pobierz PDF
                      </button>
                    </div>
                    {cert.certificate_content && (
                      <div className="mt-3 p-3 bg-white border border-gray-200 rounded text-xs text-gray-700 max-h-32 overflow-y-auto">
                        <pre className="whitespace-pre-wrap font-sans">{cert.certificate_content.substring(0, 300)}...</pre>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
